import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'

//Components
import Snack from '../../components/snack'
import Loader from '../../components/loader'
import NavBar from './components/nav-bar'

//Extras
import { styleInput } from '../../assets/coach-assets/constants/styles'
import { fontType } from '../../assets/extras'
import { doc, getDoc, updateDoc } from 'firebase/firestore'
import { auth, db } from '../../assets/connections'
import { main } from '../../assets/coach-assets/constants/colors'
import { signInWithEmailAndPassword, updatePassword } from 'firebase/auth'

const CoachSettings = () => {

    const navigate = useNavigate()

    const location = useLocation()
    const correo = location.state ? location.state.correo : null

    //Variables principales del componente
    const [variables, setVariables] = useState({
        id: correo,
        oldPassword: "",
        loading: true,
        data: {},
    })

    //Control del mensaje snack
    const showMessage = (message, status) => {
        setTimeout(() => {
            let contSnack = document.getElementById("contSnack")

            let snack = document.createElement("div")
            snack.classList.add("snack")

            snack.innerHTML = status == "success" ?
                "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #56d600;'></div>"
                : status == "warning" ?
                    "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                    : status == "error" ?
                        "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                        "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                        "<div className='snackBar' style='background-color: #c20000;'></div>"
                        : ""

            contSnack.appendChild(snack)
            setTimeout(() => {
                snack.remove()
            }, 5000)
        }, 5)
    }

    //Funcion que actualiza los datos del profesor
    const onHandleSave = async () => {
        //Validamos si los campos tienen datos
        if(variables.data.clave_profesor.length >= 6) {
            setVariables(prev => ({
                ...prev,
                loading: true
            }))

            //Primero actualizamos la contraseña del profesor
            await signInWithEmailAndPassword(auth, variables.data.correo_profesor, variables.oldPassword).then(r => {
                updatePass(r.user)
            }).catch(e => {
                console.log(e.code + " " + e.message)
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                if(e.code == "auth/wrong-password"){
                    showMessage("Clave incorrecta", "error")
                } else if(e.code == "auth/user-not-found"){
                    showMessage("Correo invalido", "error")
                } else {
                    showMessage("Error de conexion", "error")
                }
            })
        } else {
            showMessage("La clave debe de tener al menos 6 caracteres", "warning")
        }
    }
    //Ahora actualizamos la contraseña del usuario
    const updatePass = async (user) => {
        await updatePassword(user, variables.data.clave_profesor).then( r => {
            updateUserInfo()
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error al actualizar contraseña", "error")
        })
    }
    //Actualizamos la base de datos con los datos del usuario
    const updateUserInfo = async () => {
        await updateDoc(doc(db, "Profesores", variables.id), {
            clave_profesor: variables.data.clave_profesor
        }).then( r => {

            //Actualizamos en el authTokenCoach del localStorage
            const newData = {
                correo_profesor: variables.id,
                clave_profesor: variables.data.clave_profesor
            }

            localStorage.setItem("authTokenCoach", JSON.stringify(newData))

            setVariables(prev => ({
                ...prev,
                oldPassword: variables.data.clave_profesor,
                loading: false
            }))

            showMessage("Datos actualizados", "success")
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error al actualizar los datos", "error")
        })
    }

    //Funcion que cierra sesion del usuario
    const logout = async () => {

        localStorage.removeItem("authTokenCoach")

        navigate("/coach")
    }

    //Funcion que nos da los datos del profesor
    const getData = async () => {
        await getDoc(doc(db, "Profesores", correo)).then(r => {
            if (r.exists) {
                setVariables(prev => ({
                    ...prev,
                    loading: false,
                    data: r.data(),
                    oldPassword: r.data().clave_profesor
                }))
            } else {
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                showMessage("No existe el profesor", "error")
            }
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error de conexion", "error")
        })
    }

    useEffect(() => {
        const token = localStorage.getItem("authTokenCoach")

        if(!token || !location.state) {
            navigate("/coach", {
                replace: true
            })
        } else {
            getData()
        }
    }, [])

    if (variables.loading)
        return (
            <Loader
                loading={variables.loading}
            />
        )

    if (!variables.loading)
        return (
            <div
                style={{
                    flex: 1,
                    backgroundColor: "white",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    paddingBottom: "40px"
                }}
            >

                <Snack />

                <NavBar
                    title={"AJUSTES"}
                />

                <div
                    style={{
                        width: "90%",
                        padding: "10px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        maxWidth: 700
                    }}
                >

                    <p
                        style={{
                            fontWeight: "bold",
                            fontSize: "20px",
                            width: "100%",
                            textAlign: "left",
                            paddingLeft: "5px",
                            fontFamily: fontType.text
                        }}
                    >
                        Correo
                    </p>

                    <input
                        type="text"
                        placeholder="Correo"
                        value={variables.data.correo_profesor}
                        disabled
                        style={{
                            ...styleInput,
                            fontSize: "18px",
                            textAlign: "center",
                            color: "#aaa",
                            marginBottom: 10
                        }}
                    />

                    <p
                        style={{
                            fontWeight: "bold",
                            fontSize: "20px",
                            width: "100%",
                            textAlign: "left",
                            paddingLeft: "5px",
                            fontFamily: fontType.text,
                        }}
                    >
                        Clave
                    </p>

                    <input
                        type="text"
                        placeholder="Clave"
                        value={variables.data.clave_profesor}
                        style={{
                            ...styleInput,
                            fontSize: "18px",
                            color: "black",
                            textAlign: "center"
                        }}
                        onChange={(e) =>
                            setVariables((prev) => ({
                                ...prev,
                                data: {
                                    ...prev.data,
                                    clave_profesor: e.target.value
                                }
                            }))
                        }
                    />

                    <button
                        style={{
                            width: "70%",
                            backgroundColor: main,
                            borderRadius: "10px",
                            marginTop: 50,
                            cursor: "pointer",
                            border: "none",
                            padding: 15,
                        }}
                        onClick={onHandleSave}
                    >
                        <span
                            style={{
                                fontFamily: fontType.title,
                                color: "white",
                                fontSize: 20
                            }}
                        >
                            ACTUALIZAR
                        </span>
                    </button>

                    <button
                        style={{
                            width: "70%",
                            backgroundColor: "#4e0d0dff", // equivale a red.800
                            borderRadius: "10px",
                            marginTop: "8px",
                            cursor: "pointer",
                            border: "none",
                            padding: 15
                        }}
                        onClick={logout}
                    >
                        <span
                            style={{
                                fontFamily: fontType.title,
                                color: "white",
                                fontSize: 20,
                            }}
                        >
                            CERRAR SESION
                        </span>
                    </button>
                </div>
            </div>
        )
}

export default CoachSettings